(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('UtilHelper', UtilHelper)

    /** @ngInject */
    function UtilHelper(NotifyHelper) {
        const UtilHelper = {
            convertToMomentDate,
            isScreenSmaller,
            setErrorMessageForm,
            removeErrorMessageForm,
            successCallback,
            errorCallback
        };

        return UtilHelper;

        function isScreenSmaller(size) {
            return Modernizr.mq(`(max-width: ${size}px)`);
        }

        function convertToMomentDate(date) {
            let dateReplaced = date.replace(/[//"]/g, '-');
            let dateSplitted = dateReplaced.split("-");

            let finalDate = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;

            return moment(finalDate);
        }

        function setErrorMessageForm(input, text = null, centerElement = false) {
            if (!$(input).parent().find('.validationMessage').length) {

                let errorText = "Este campo é Obrigatório"
                let centerClass = "";

                if (text != null)
                    errorText = text;

                if (centerElement)
                    centerClass = "text-center";

                $(input).parent()
                    .append(`<label class=\'control-label has-error validationMessage ${centerClass}\'>${errorText}</label>`);

                $(input)
                    .addClass('has-error')
                    .parents('.form-group')
                    .addClass('has-error');
            }

            $([document.documentElement, document.body]).animate({
                scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
            }, 600);
        }

        function removeErrorMessageForm(input) {
            $(input)
                .parent()
                .find('.validationMessage')
                .remove();

            $(input)
                .removeClass('has-error')
                .parents('.form-group')
                .removeClass('has-error');
        }

        function successCallback(type = 'create') {
            let message = '';

            if (type == 'create')
                message = 'Registro salvo com sucesso';

            else if (type == 'update')
                message = 'Registro atualizado com sucesso';

            else if (type == 'delete')
                message = 'Registro apagado com sucesso';

            else if (type == 'image')
                message = 'Imagem salva com sucesso';

            else if (type == 'migrate')
                message = 'Registros migrados com sucesso';

            NotifyHelper.success(message);
        }

        function errorCallback(error) {
            let message = 'Ocorreu um erro inesperado, por favor tente novamente!';

            if (error && error.data && error.data.ErrorCode) {
                if (error.data.ErrorCode == 404 || error.data.ErrorCode == 409)
                    message = error.data.ErrorMessage || 'Ocorreu um erro inesperado, por favor tente novamente!';

                else if (error.data.ErrorCode == 422) {
                    const errorMessage = error.data.ErrorMessage;
                    let parsedErrorMessage;

                    if (typeof errorMessage === 'string')
                        parsedErrorMessage = tryParseJSON(errorMessage);

                    if (typeof parsedErrorMessage === typeof []) {
                        let messages = parsedErrorMessage;
                        message = '';

                        if (messages) {
                            for (let i = 0; i < messages.length; i++)
                                message += messages[i].ErrorMessage;
                        }
                    } else
                        message = errorMessage;
                }
            } else if (error && error.data && error.data.error && error.data.error_description) {
                if (error.data.error == 'invalid_grant')
                    message = error.data.error_description;
            }

            NotifyHelper.error(message);
        }

        function tryParseJSON(jsonString) {
            try {
                var o = JSON.parse(jsonString);

                // Handle non-exception-throwing cases:
                // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
                // but... JSON.parse(null) returns null, and typeof null === "object",
                // so we must check for that, too. Thankfully, null is falsey, so this suffices:
                if (o && typeof o === 'object')
                    return o;
            } catch (e) {
                return false;
            }

            return false;
        }
    }
}());